import React from "react";
import { useTranslation } from "react-i18next";
import { useRootAppStore } from "@hooks";
import FormInputField from "../../shared/desktop/inputs/FormInputField";
import { FormProvider, useForm } from "react-hook-form";
import { observer } from "mobx-react";
import { RegistrationFormData } from "@data-types/membership/registration";
import { FormButton } from "@components/buttons";
import { EmailPattern } from "@common/constants";
import ReactMarkdown from "react-markdown";
import { MarketingInteractionTypeEnum } from "@data-types/analytics-tracker/MarketingInteractionTypeEnum";
import { analyticsTracker } from "@utils/analytics";
import { CheckboxField } from "@components/inputs/desktop";
import { useFixBody } from "@state/hooks/shared";

export default observer(function OnboardingNewsletterPopup(props: {
	isOnboardingNewsletterPopupActive?: boolean;
}) {
	const { t } = useTranslation();

	const {
		onboardingWelcomePopupStore: {
			onboardingNewsletterStore: { acceptNewsletter, hidePopup },
		},
	} = useRootAppStore();

	useFixBody(true, props.isOnboardingNewsletterPopupActive);

	const methods = useForm({
		mode: "onChange",
	});

	const { handleSubmit } = methods;

	const submitFunction = async (formData: RegistrationFormData) => {
		analyticsTracker.trackMarketingInteraction(
			MarketingInteractionTypeEnum.NewsletterConfirm
		);
		await acceptNewsletter(formData.email);
	};

	return (
		<div className="at-newsletterModal popup popup--bonus">
			<div className="popup__card popup--bonus__card">
				<div className="popup--bonus__header">
					<img
						className="popup--bonus__logo"
						src="/assets/images/logo-vibrant.svg"
						alt=""
					/>

					<button
						type="button"
						className="popup--bonus__close btn btn--round btn--round--sml btn--primary--inverted btn--icon"
						onClick={() => {
							analyticsTracker.trackMarketingInteraction(
								MarketingInteractionTypeEnum.NewsletterClose
							);
							hidePopup();
						}}
					>
						<i className="u-icon u-icon--tny u-icon--close u-color--text--primary" />
					</button>
				</div>

				<div className="popup--bonus__body">
					<FormProvider {...methods}>
						<form
							className="form popup--bonus__content"
							onSubmit={handleSubmit(submitFunction)}
						>
							<div className="popup--bonus__text">
								<div className="popup--bonus__title">
									<ReactMarkdown className="">
										{t(
											"USER.POPUPS.ONBOARDING_WELCOME_POPUPS.NEWSLETTER.TITLE"
										)}
									</ReactMarkdown>
								</div>
								<div className="popup--bonus__desc">
									{t(
										"USER.POPUPS.ONBOARDING_WELCOME_POPUPS.NEWSLETTER.DESCRIPTION"
									)}
								</div>

								<FormInputField
									{...methods.register("email")}
									type="email"
									pattern={EmailPattern}
									placeholder="USER.POPUPS.ONBOARDING_WELCOME_POPUPS.NEWSLETTER.EMAIL_PLACEHOLDER"
									inputClassName="input input--med"
									required
								/>

								<CheckboxField
									id="checkbox"
									name="newsletter-checkbox"
									label="USER.POPUPS.ONBOARDING_WELCOME_POPUPS.NEWSLETTER.CHECKBOX_PLACEHOLDER"
									checkboxClassname="input--check"
									labelClassName="input--check__label"
									required
								/>
							</div>

							<div className="popup--bonus__footer">
								<FormButton
									type="submit"
									className="popup--bonus__btn btn btn--base btn--primary"
									btnText={t(
										"USER.POPUPS.ONBOARDING_WELCOME_POPUPS.NEWSLETTER.SUBSCRIBE_BTN"
									)}
								/>
							</div>
						</form>
					</FormProvider>

					<div className="popup--bonus__media">
						<img
							className="popup--bonus__img"
							src="/assets/images/bg/athlete.png"
							alt=""
						/>
					</div>
				</div>
			</div>
		</div>
	);
});
